/* eslint-disable import/no-named-as-default */
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

const popularSearches = [
  {
    title: "יצרני צמיגים מובילים",
    key: "manufacturers",
    links: [
      {
        key: "pirelli-moto-tires",
        text: "פירלי",
        url: "/list/moto/by/brand/Pirelli",
      },
      {
        key: "bridgestone-moto-tires",
        text: "ברידג׳סטון",
        url: "/list/moto/by/brand/Bridgestone",
      },
      {
        key: "michelin-moto-tires",
        text: "מישלין",
        url: "/list/moto/by/brand/Michelin",
      },
      {
        key: "continental-moto-tires",
        text: "Continental",
        url: "/list/moto/by/brand/Continental",
      },
      {
        key: "metzeler-moto-tires",
        text: "מצלר",
        url: "/list/moto/by/brand/Metzeler",
      },
      {
        key: "sunf-moto-tires",
        text: "Sun-F",
        url: "/list/moto/by/brand/SUNF",
      },
      {
        key: "maxxis-moto-tires",
        text: "Maxxis",
        url: "/list/moto/by/brand/Maxxis",
      },
    ],
  },
  {
    title: "מידות צמיגים פופולריות",
    key: "tire_sizes",
    links: [
      {
        key: "tires-of-size-180",
        text: "180/55ZR17",
        url: "/list/moto/180/55/17",
      },
      {
        key: "tires-of-size-160",
        text: "160/60ZR17",
        url: "/list/moto/160/60/17",
      },
      {
        key: "tires-of-size-120-70-17",
        text: "120/70ZR17",
        url: "/list/moto/120/70/17",
      },
      {
        key: "tires-of-size-140-70-17",
        text: "140/70R17",
        url: "/list/moto/140/70/17",
      },
      {
        key: "tires-of-size-120-90-18",
        text: "120/90-18",
        url: "/list/moto/120/90/18",
      },
      {
        key: "tires-of-size-110-100-18",
        text: "110/100-18",
        url: "/list/moto/110/100/18",
      },
    ],
  },
];

const styles = (theme) => ({
  footer: {
    backgroundColor: "#f7f8fb",
    padding: `0 ${theme.spacing(2)}px ${theme.spacing(3)}px`,
  },
  inner: {
    maxWidth: 1180,
    marginLeft: "auto",
    marginRight: "auto",
    borderTop: "1px solid #e6e9ef",
    paddingTop: theme.spacing(3),
  },
  intro: {
    marginBottom: theme.spacing(2),
  },
  eyebrow: {
    color: "#9aa5b1",
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 0.6,
    marginBottom: theme.spacing(0.5),
    textTransform: "uppercase",
  },
  title: {
    color: "#1f2933",
    fontSize: 18,
    fontWeight: 800,
  },
  group: {
    marginBottom: theme.spacing(2.5),
  },
  sectionTitle: {
    color: "#3e4c59",
    fontSize: 14,
    fontWeight: 800,
    marginBottom: theme.spacing(1),
  },
  chipList: {
    display: "flex",
    flexWrap: "wrap",
    margin: theme.spacing(-0.5),
  },
  typoLink: {
    display: "inline-flex",
    alignItems: "center",
    minHeight: 34,
    margin: theme.spacing(0.5),
    padding: `${theme.spacing(0.75)}px ${theme.spacing(1.4)}px`,
    border: "1px solid #e0e6ed",
    borderRadius: 999,
    backgroundColor: "#ffffff",
    color: "#52606d",
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.2,
    textDecoration: "none",
    "&:hover": {
      borderColor: "#c8d2dc",
      color: "#111827",
      backgroundColor: "#fdfdfd",
    },
  },
  "@media (min-width: 720px)": {
    footer: {
      paddingRight: theme.spacing(4),
      paddingLeft: theme.spacing(4),
    },
    inner: {
      display: "grid",
      gridTemplateColumns: "minmax(220px, 0.45fr) minmax(0, 1fr)",
      gap: theme.spacing(4),
    },
    intro: {
      marginBottom: 0,
    },
    group: {
      marginBottom: 0,
    },
  },
});

function CatalogFooter({ classes }) {
  return (
    <footer className={classNames(classes.footer)}>
      <div className={classes.inner}>
        <div className={classes.intro}>
          <Typography className={classes.eyebrow} component="p">
            חיפושים מהירים
          </Typography>
          <Typography className={classes.title} component="h2">
            מותגים ומידות מבוקשים
          </Typography>
        </div>

        <Grid container spacing={3}>
          {popularSearches.map((group) => (
            <Grid item key={group.key} md={6} xs={12}>
              <div className={classes.group}>
                <Typography className={classes.sectionTitle} component="h3">
                  {group.title}
                </Typography>
                <div className={classes.chipList}>
                  {group.links.map((item) => (
                    <Link
                      className={classes.typoLink}
                      key={item.key}
                      to={item.url}
                    >
                      {item.text}
                    </Link>
                  ))}
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </footer>
  );
}

CatalogFooter.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(CatalogFooter);
